import {RSAA} from "redux-api-middleware";
import {API_ENDPOINT, AUTH_HEADERS} from "../../../util/constants";
import * as types from "../../types";
import {handleUnauthorizedAccess} from "../../../util/utility";

/**
 *  *  *  *  *   *  *  *  *  *   G E T _ M Y _ S U B S C R I P T I O N _ P A C K A G E *  *  *  *  *   *  *  *  *  *
 */
export function getMySubscriptionPackage(token, api_token, width, height) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/broadcaster/subscriptions?api_token=${api_token}`,
            method: 'GET',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            types: [types.GET_MY_SUBSCRIPTION_PACKAGES_REQUEST, types.GET_MY_SUBSCRIPTION_PACKAGES_RECEIVE, {
                type: types.GET_MY_SUBSCRIPTION_PACKAGES_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export const resetMySubscriptionPackage = () => ({
    type: types.RESET_GET_MY_SUBSCRIPTION_PACKAGES,
    payload: null
});

/**
 *  *  *  *  *   *  *  *  *  *   G E T _ M Y _ S U B S C R I P T I O N _ P A C K A G E *  *  *  *  *   *  *  *  *  *
 */

/**
 *  *  *  *  *   *  *  *  *  *   U P D A T E _ M Y _ S U B S C R I P T I O N _ P A C K A G E *  *  *  *  *   *  *  *  *  *
 */
export function updateMySubscription(token, api_token, id) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/broadcaster/subscriptions/${id}?api_token=${api_token}`,
            method: 'GET',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            types: [types.UPDATE_SUBSCRIPTION_PACKAGE_REQUEST, types.UPDATE_SUBSCRIPTION_PACKAGE_RECEIVE, {
                type: types.UPDATE_SUBSCRIPTION_PACKAGE_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export const resetUpdateMySubscription = () => ({
    type: types.RESET_UPDATE_SUBSCRIPTION_PACKAGE,
    payload: null
});
/**
 *  *  *  *  *   *  *  *  *  *  U P D A T E _ M Y _ S U B S C R I P T I O N _ P A C K A G E *  *  *  *  *   *  *  *  *  *
 */

/**
 *  *  *  *  *   *  *  *  *  *   G E T _ M Y _ S U B S C R I B E R S *  *  *  *  *   *  *  *  *  *
 */
export function getMySubscribers(token, api_token) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/broadcaster/subscribers?api_token=${api_token}`,
            method: 'GET',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            types: [types.GET_SUBSCRIBERS_REQUEST, types.GET_SUBSCRIBERS_RECEIVE, {
                type: types.GET_SUBSCRIBERS_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export const resetMySubscribers = () => ({
    type: types.RESET_GET_SUBSCRIBERS,
    payload: null
});
/**
 *  *  *  *  *   *  *  *  *  *   G E T _ M Y _ S U B S C R I B E R S *  *  *  *  *   *  *  *  *  *
 */